import { render } from "./SectionHeader.vue?vue&type=template&id=2308f9ba"
import script from "./SectionHeader.vue?vue&type=script&lang=js"
export * from "./SectionHeader.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./SectionHeader.vue?vue&type=style&index=0&id=2308f9ba&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script